import type { PropsWithChildren } from "react";
import { createContext } from "react";

interface ReportTemplateContextType {
  deleteTemplates: (ids: string[]) => void;
}
const ReportTemplateUiManagerContext = createContext<ReportTemplateContextType | undefined>(undefined);

export const ReportTemplateUiManagerContextProvider = ({
  children,
  ...props
}: PropsWithChildren<ReportTemplateContextType>) => {
  return <ReportTemplateUiManagerContext value={props}>{children}</ReportTemplateUiManagerContext>;
};

export default ReportTemplateUiManagerContext;
